import { render, staticRenderFns } from "./hits.vue?vue&type=template&id=29db2319&scoped=true&"
import script from "./hits.vue?vue&type=script&lang=js&"
export * from "./hits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29db2319",
  null
  
)

export default component.exports